// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__y8Qfq","styledLogBtn":"Header_styledLogBtn__CoOyy","header":"Header_header__eV3jf","right":"Header_right__YfV0q"};